/* tslint:disable:variable-name */
import { Affiliate } from '../Affiliate';
import { CaseContract } from '../CaseDocument/CaseContract';
import { Proposal } from '../CaseDocument/Proposal';
import { CaseDepartmentAssignment } from '../Department/CaseDepartmentAssignment';
import { CaseDistribution } from '../Distribution/CaseDistribution';
import { AppDocument } from '../Document/AppDocument';
import { DocumentType } from '../DocumentType';
import { AppointedCourt } from '../Entity/AppointedCourt';
import { Note } from '../Note';
import { EmailHistory } from '../Notification/EmailHistory';
import { SmsHistory } from '../Notification/SmsHistory';
import { Packager } from '../Packager/Packager';
import { CasePaymentPlan } from '../Payment/CasePaymentPlan';
import { PaymentCard } from '../Payment/PaymentCard';
import { Payment } from '../Payment/Payment';
import { PaymentTerm } from '../Payment/PaymentTerm';
import { OppwaOrder } from '../Payment/Transaction/OppwaOrder';
import { Product } from '../Product';
import { CallStatus } from '../Status/CallStatus';
import { PackagerStatus } from '../Status/PackagerStatus';
import { PaymentStatus } from '../Status/PaymentStatus';
import { Status } from '../Status/Status';
import { Task } from '../Task/Task';
import { User } from '../User/User';
import { CaseAsset } from './CaseAsset';
import { CaseAssetBankAccount } from './CaseAssetBankAccount';
import { CaseAssetOther } from './CaseAssetOther';
import { CaseAssetProperty } from './CaseAssetProperty';
import { CaseAssetVehicle } from './CaseAssetVehicle';
import { CaseEntity } from './CaseEntity';
import { CaseExpense } from './CaseExpense';
import { CaseIncome } from './CaseIncome';
import { CasePublicDebt } from './CasePublicDebt';
import { Lead } from './Lead';
import { UserCaseRelationValidation } from './UserCaseRelationValidation';
import { CaseInvoiceStatus } from '../Status/CaseInvoiceStatus';
import { CaseLoan } from './CaseLoan';
import { DistributionCaseTerms } from '../Payment/DistributionCaseTerms';
import { ContractRequest } from '../CaseDocument/ContractRequest';
import { CaseCreditor, CaseCreditorPivot } from './CaseCreditor';
import { TransferRequest } from './TransferRequest';
import { CaseStatusLog } from './CaseStatusLog';

export class CasePrefillData {
  affiliate_id?: number;
  legal_advisor_id?: number;
  verifier_id?: number;
}

export class CaseVariable {
  label: string;
  description?: string;
}

export class Case {
  id?: number;
  uuid?: string;
  product_id?: number;
  parent_id?: number;
  parent_relation?: 'clone' | 'fork';
  packager_status_id?: number;
  status_id: number;
  payment_status_id: number;
  call_status_id?: number;
  case_invoice_status_id?: number;
  user_id: number;
  partner_user_id: number;
  packager: Packager;
  packager_id: number;
  original_packager_id: number;
  locked_by_id: number;
  locked_no_products: boolean;

  ref_number: string;
  joint_application: boolean;
  active: boolean | 0 | 1;
  complete: boolean | 0 | 1;
  payment_active: boolean | 0 | 1;
  require_lso_qualifiers: boolean | 0 | 1;
  product_assigned_at: Date | string;
  distribution_nonviable?: boolean | 0 | 1;
  dvl_ref_number?: string;
  epi_ref_number?: string;
  uni_ref_number?: string;
  deu_ref_number?: string;
  is_test?: boolean | 0 | 1;
  last_action_at?: string | Date;
  login_activatable?: boolean | 0 | 1;
  updatable_by_packager?: boolean | 0 | 1;
  login_activated_at?: string | Date;
  created_at?: Date | string;
  updated_at?: Date | string;
  deleted_at?: Date | string;
  digital_signature?: string;
  doc_version?: 1 | 2 | 3;
  debt_amount: number;
  send_document_list_status?: boolean | 0 | 1;
  packager_transferred_docs?: boolean | 0 | 1;
  microlenders?: boolean;
  debt_reduction?: number;
  sum_total_reduction?: number;
  sum_total_debt_amount?: number;
  sum_total_negotiated_amount?: number;
  iban?: string;
  amount_paid?: number;
  amount_unpaid?: number;
  active_debt?: number;
  is_above50_percent?: boolean;

  // Relations
  client?: User;
  partner?: User;
  aep?: any;
  dispute_letter?: any;
  creditors: Array<CaseCreditorPivot>;
  secured_creditors: Array<CaseCreditorPivot>   = [];
  unsecured_creditors: Array<CaseCreditorPivot> = [];
  unsecured_case_creditors: Array<CaseCreditor> = [];
  secured_case_creditors: Array<CaseCreditor>   = [];
  public_debts: Array<CasePublicDebt>           = [];
  claim_creditors: Array<CaseCreditorPivot>     = [];
  proposal?: Proposal;
  income                                        = new CaseIncome();
  expense                                       = new CaseExpense();
  debt_payment_plan: CasePaymentPlan;
  payment_plans: CasePaymentPlan;
  config: any;
  assets: Array<CaseAsset>;
  file_requests?: Array<DocumentType>;
  partner_file_requests?: Array<DocumentType>;
  files?: Array<any>;
  legal_documents?: Array<any>;
  pending_files?: Array<any>;
  client_files?: Array<any>;
  partner_files?: Array<any>;
  contracts?: Array<any>;
  latest_contract?: CaseContract;
  latest_signed_contract?: CaseContract;
  latest_contract_request?: ContractRequest;
  status?: Status;
  payment_status?: PaymentStatus;
  call_status?: CallStatus;
  case_invoice_status?: CaseInvoiceStatus;
  product?: Product;
  payments?: Array<Payment>;
  latest_payment?: Payment;
  oppwa_orders?: Array<OppwaOrder>;
  terms?: Array<PaymentTerm>;
  unpaid_terms?: Array<PaymentTerm>;
  paid_terms?: Array<PaymentTerm>;
  missed_terms?: Array<PaymentTerm>;
  payment_cards?: Array<PaymentCard>;
  last_payment_card?: PaymentCard;
  notes?: Array<Note>;
  lead?: Lead;
  case_contract_logs?: Array<any>;
  email_history?: Array<EmailHistory>;
  sms_history?: Array<SmsHistory>;
  payment_notes?: Array<Note>;
  case_status_logs?: Array<any>;
  latest_case_status_log?: any;
  case_payment_status_logs?: Array<any>;
  case_general_logs?: Array<any>;
  affiliate?: Array<Affiliate>;
  propuesta_modelo?: any;
  propuesta_modelo_logs?: Array<any>;
  contract_file_logs?: Array<any>;
  tasks?: Array<Task>;
  case_entities?: CaseEntity;
  linked_by_cases?: Array<Case>;
  linked_cases?: Array<Case>;
  relation_validations?: Array<UserCaseRelationValidation>;
  distribution?: CaseDistribution;
  transfer_request?: TransferRequest;
  packager_status: PackagerStatus;
  original_packager: Packager;
  client_auto_exoneration_document?: AppDocument;
  fees?: Array<PaymentTerm>;
  debt_plan_fees?: Array<PaymentTerm>;

  payment = new CasePaymentPlan();

  department_assignments?: Array<CaseDepartmentAssignment>;
  appointed_court?: AppointedCourt;
  creditor_list_documents?: Array<AppDocument>;
  asset_list_documents?: Array<AppDocument>;
  debt_cancellation_request_documents?: Array<AppDocument>;
  exoneration_documents?: Array<AppDocument>;
  proposal_documents?: Array<AppDocument>;
  scheduled_dialer_cases?: Array<any>;
  case_fence?: any;
  lawyer_department_assignment?: Array<CaseDepartmentAssignment>;
  latest_status_log?: CaseStatusLog;
  distribution_case_terms?: Array<DistributionCaseTerms>;

  // App Helpers
  signature_verified?: boolean;
  linked_cases_ids: Array<number>;
  // Deprecated, TODO: rework
  files_by_type?: any;
  client_files_by_type?: any;
  partner_files_by_type?: any;
  files_by_creditor?: any;
  files_by_public_debt?: any;
  partner_files_by_creditor?: any;
  partner_files_by_public_debt?: any;
  legal_documents_client?: any;
  legal_documents_partner?: any;
  client_files_by_bank?: any;
  partner_files_by_bank?: any;
  court_documents_client?: any;
  court_documents_partner?: any;
  assets_by_type: {
    bank_accounts: CaseAssetBankAccount[];
    vehicles: CaseAssetVehicle[];
    properties: CaseAssetProperty[];
    other: CaseAssetOther[];
  };
  earnings?: number;
  locked_by?: Case;
  case_loan: CaseLoan;
  primary_conversion_cost?: number;
  secondary_conversion_cost?: number;
  volume_bonus_conversion_cost?: number;
  total_conversion_cost_sum?: number;
  parent?: Case;
  forked_case?: Case;
  cloned_case?: Case;
  doc_status_id: number;
  loan_request_pdf_location: string;
  target_monthly_payment: any;
  client_signed_proposal?: boolean;
  proposal_pdf?: any;
  creditor_proposal_pdf?: any;

  // Debt Settlement
  settlement_received?: number;
  settlement_fees?: number;
  settlement_balance?: number;
  settlement_paid?: number;
}
